module.exports = __webpack_public_path__ + "static/dropdown-menu-type-of-error-1-f17a5971c486c3aa369143a0226b77b6.png";